import { RETAINER_REQUEST_STATUS } from '../hooks/useRetainerRequest';

// handle case log display boolean for retainer request
export const handleRetainerRequesrtCaseLogDisplay = (log) => {
    let logBool = {
        showDelivered: false,
        showProductionInProgress: false,
        showRetainerRequest: true, // default to true, if the reatainer request is created with new case (not after all delivered) then false
        // showRetainerRequest:false
    };

    if (!log || !log?.case_retainer_request) return logBool;
    // display case log when delivered_flag === true and status is not null
    if (log.case_retainer_request?.delivered_flag) {
        if (
            log.case_retainer_request.retainer_request_id &&
            log.case_retainer_request?.status &&
            log.case_retainer_request?.status === RETAINER_REQUEST_STATUS.RETAINER_REQUEST_DEL
        ) {
            logBool.showDelivered = true;
        }
        if (!log.case_retainer_request.retainer_request_id && log.case_retainer_request.retainer_id) {
            logBool.showDelivered = true;
        }
    }
    // display case log when production_flag === true and status is not null
    if (log.case_retainer_request?.production_flag && log.case_retainer_request?.status) {
        logBool.showProductionInProgress = true;
    }
    // only allow dispaly retainer request when caseType === 'RETAINER' and the retainer request is created after all delivered to display
    if (
        log.case_retainer_request &&
        !log.case_retainer_request?.is_case_created_after_all_delivered &&
        log.case_type === 'RETAINER' &&
        log.case_retainer_request.retainer_request_id
    ) {
        logBool.showRetainerRequest = false;
    }
    return logBool;
};

export function getAlignerLogMsg(alignerRequestDetail) {
    let displayStr = alignerRequestDetail.step_no;
    if (
        alignerRequestDetail.arch &&
        alignerRequestDetail.arch.length > 0 &&
        ['upper', 'lower', 'upperAndLower'].includes(alignerRequestDetail.arch)
    ) {
        return displayStr + ' ' + this.get(`aligner.${alignerRequestDetail.arch}`);
    }
    return displayStr + ' ' + alignerRequestDetail.thickness;
}
